import type { Schema } from '@dealdesk/api-schema';
import { z } from 'zod';

import { M } from '@/business';

import { SCOPE_CHOICES, fromScopeMap, toScopeMap, type ScopeChoice } from '../model/permissions';

type Role = Schema<'Role'>;

export const roleSchema = z.object({
  name: z.string({ error: M.required }).trim().min(2, M.required),
  description: z.string().trim(),
  /** One choice per permission code; "none" = not granted. */
  scopes: z.record(z.string(), z.enum(SCOPE_CHOICES as [ScopeChoice, ...ScopeChoice[]])),
});
export type RoleValues = z.infer<typeof roleSchema>;

/** Form values for an existing role, a copy of one (name suffixed by the caller), or an empty new role. */
export function toRoleValues(codes: readonly string[], role?: Pick<Role, 'name' | 'description' | 'permissions'> | null, nameOverride?: string): RoleValues {
  return {
    name: nameOverride ?? role?.name ?? '',
    description: role?.description ?? '',
    scopes: toScopeMap(codes, role?.permissions ?? []),
  };
}

export function toRoleInput(codes: readonly string[], v: RoleValues): Schema<'RoleInput'> {
  return { name: v.name.trim(), description: v.description.trim(), permissions: fromScopeMap(codes, v.scopes) };
}
